const layout = {
  sidebar: {
    minWidth: 60,
    maxWidth: 224,
  },
  aside: {
    width: 261,
  },
  content: {
    topPadding: 25,
    rightPadding: 10,
    leftPadding: 40,
  },
};
export default layout;
